import {
  typedCollection,
  getCollection,
  where,
  orderBy,
} from '@/lib/firebase/firestore'
import type { ServiceDocument, ServiceCategoryDocument } from '@/types'

const servicesCol = () => typedCollection<ServiceDocument>('services')
const categoriesCol = () => typedCollection<ServiceCategoryDocument>('serviceCategories')

export const servicesService = {
  async getPublishedServices(): Promise<Array<ServiceDocument & { id: string }>> {
    return getCollection(
      servicesCol(),
      where('isPublished', '==', true),
      orderBy('order', 'asc')
    )
  },

  async getCategories(): Promise<Array<ServiceCategoryDocument & { id: string }>> {
    return getCollection(categoriesCol(), orderBy('order', 'asc'))
  },
}
